<template>
  <div>
    <div
      v-if="dialog_show"
      class="fixed inset-0 z-3000 bg-black bg-opacity-50 flex items-center justify-center p-4"
      @click.self="dialog_show = false"
    >
      <div class="bg-white rounded-2xl shadow-xl w-full max-w-sm overflow-hidden" dir="rtl">
        <div class="px-5 py-4 border-b border-gray-100">
          <h3 class="text-base font-bold text-gray-900">{{ dialog_title }}</h3>
        </div>
        <div class="px-5 py-4">
          <p class="text-sm text-gray-700 leading-6 whitespace-pre-wrap">{{ dialog_summary }}</p>
        </div>
        <div class="px-5 py-4 border-t border-gray-100 flex justify-end">
          <button
            type="button"
            class="px-5 py-2.5 rounded-lg bg-green-600 hover:bg-green-700 text-white text-sm font-semibold transition-colors"
            @click="dialog_show = false"
          >
            {{ $t('ok') }}
          </button>
        </div>
      </div>
    </div>

    <transition name="toast-fade">
      <div
        v-if="toast_snackbar"
        class="fixed left-1/2 transform -translate-x-1/2 bottom-24 z-3100 max-w-sm w-90% px-4 py-3 rounded-xl shadow-lg text-sm font-medium text-white text-center"
        :class="toastClass"
        dir="rtl"
      >
        {{ toast_text }}
      </div>
    </transition>
  </div>
</template>

<script>
  import { bus } from '../main.js'
  export default {
    name: 'AppDialog',
    data () {
      return {
        dialog_show : false,
        dialog_title: '',
        dialog_summary : '',

        toast_snackbar : false,
        toast_timeout : -1,
        toast_text : '',
        toast_color : '',
        toastTimer: null,
      }
    },
    computed: {
      toastClass () {
        if (this.toast_color === 'success') return 'bg-green-600'
        if (this.toast_color === 'error') return 'bg-red-600'
        if (this.toast_color) return this.toast_color
        return 'bg-gray-800'
      }
    },
    mounted () {
      this.onShowDialog = (name) => {
        this.dialog_show = true
        this.dialog_title = name[0]
        this.dialog_summary = name[1]
      }
      this.onShowToast = (name) => {
        this.toast_snackbar = true
        this.toast_timeout = name[0]
        this.toast_text = name[1]

        if (name.length > 2) {
          if (name[2] === 'success') {
            this.toast_color = 'success'
          } else if (name[2] === 'error') {
            this.toast_color = 'error'
          } else {
            this.toast_color = name[2]
          }
        } else {
          const message = name[1] || ''
          const successKeywords = ['کد ارسال شد', 'با موفقیت', 'موفقیت‌آمیز', 'ارسال شد', 'ذخیره شد', 'تایید شد', 'ثبت شد', 'انجام شد', 'ورود موفق']
          const errorKeywords = ['خطا', 'اشتباه', 'نامعتبر', 'یافت نشد', 'ثبت نشده', 'وجود ندارد', 'امکان‌پذیر نیست', 'ناموفق', 'لطفاً']

          const isSuccess = successKeywords.some(keyword => message.includes(keyword))
          const isError = errorKeywords.some(keyword => message.includes(keyword))

          if (isSuccess && !isError) {
            this.toast_color = 'success'
          } else if (isError) {
            this.toast_color = 'error'
          } else {
            this.toast_color = 'error'
          }
        }

        if (this.toastTimer) {
          clearTimeout(this.toastTimer)
          this.toastTimer = null
        }
        if (this.toast_timeout > 0) {
          this.toastTimer = setTimeout(() => {
            this.toast_snackbar = false
          }, this.toast_timeout)
        }
      }

      bus.$on('show_dialog', this.onShowDialog)
      bus.$on('show_toast', this.onShowToast)
    },
    beforeDestroy () {
      bus.$off('show_dialog', this.onShowDialog)
      bus.$off('show_toast', this.onShowToast)
      if (this.toastTimer) {
        clearTimeout(this.toastTimer)
      }
    }
  }
</script>

<style scoped>
.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.toast-fade-enter,
.toast-fade-leave-to {
  opacity: 0;
  transform: translate(-50%, 8px);
}
</style>
